import compact from 'lodash/compact';
import { ListBooking } from 'types';
import { ItemLinkProps } from '../Components/ItemLinks/ItemLink';
import { viewDetailsLink } from 'lib/gaTracking/bookingListPageEvents';
import { scheduledPaymentUpdateCreditCardLinkSelected } from 'lib/gaTracking/crossPageEvents';
import UpdateCreditCardAlert from './UpdateCreditCardAlert';
import { shouldUpdatePaymentMethod } from '../../helpers';
import { getUpdatePaymentMethodPageLink } from 'lib/links';

export const generateViewBookingDetailsItemLink = (booking: ListBooking, onTrack: () => void): ItemLinkProps => ({
  label: 'View details',
  url: booking.links.manage,
  onClick: () => {
    onTrack();
    viewDetailsLink(booking);
  },
  'data-testid': 'view-booking-details-link',
});

export const generateUpdatePaymentMethodItemLink = (booking: ListBooking): ItemLinkProps | null => {
  const {
    flags: { isFinalising, isChangeInProgress },
  } = booking;
  const isPaymentMethodUpdateRequire = shouldUpdatePaymentMethod(booking);

  if (isFinalising || isChangeInProgress || !isPaymentMethodUpdateRequire) {
    return null;
  }

  const updatePaymentMethodItemLink = {
    label: 'Update credit card',
    url: getUpdatePaymentMethodPageLink(booking.id),
    onClick: scheduledPaymentUpdateCreditCardLinkSelected,
    'data-testid': 'update-payment-method-link',
    alert: <UpdateCreditCardAlert />,
  };

  return updatePaymentMethodItemLink;
};

export const generateActionItemLinks = (booking: ListBooking, onTrack: () => void): ItemLinkProps[] => {
  const detailsLink = generateViewBookingDetailsItemLink(booking, onTrack);
  const updatePaymentMethodLink = generateUpdatePaymentMethodItemLink(booking);

  return compact([detailsLink, updatePaymentMethodLink]);
};
